/**
 * Hydrate <time datetime data-format> with the user's locale and timezone (Intl).
 */
(function () {
  function createSeenSet() {
    if (typeof WeakSet === 'function') return new WeakSet();
    var s = new Set();
    return {
      has: function (el) { return s.has(el); },
      add: function (el) { s.add(el); },
    };
  }

  function optsForFormat(fmt) {
    if (fmt === 'date') {
      return { year: 'numeric', month: 'short', day: 'numeric' };
    }
    if (fmt === 'time') {
      return { hour: '2-digit', minute: '2-digit', second: '2-digit' };
    }
    if (fmt === 'month') {
      return { month: 'long' };
    }
    if (fmt === 'relative') {
      return null;
    }
    return { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
  }

  function formatOne(el) {
    var dt = el.getAttribute('datetime');
    if (!dt) return;
    var d = new Date(dt);
    if (isNaN(d.getTime())) return;
    var fmt = el.getAttribute('data-format') || 'datetime';
    if (fmt === 'relative') {
      try {
        var rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
        var sec = (d.getTime() - Date.now()) / 1000;
        var abs = Math.abs(sec);
        var unit = 'second';
        var val = Math.round(sec);
        if (abs >= 60) {
          val = Math.round(sec / 60);
          unit = 'minute';
        }
        if (abs >= 3600) {
          val = Math.round(sec / 3600);
          unit = 'hour';
        }
        if (abs >= 86400) {
          val = Math.round(sec / 86400);
          unit = 'day';
        }
        el.textContent = rtf.format(val, unit);
      } catch (e) {
        el.textContent = d.toLocaleString();
      }
      return;
    }
    var o = optsForFormat(fmt);
    try {
      el.textContent = new Intl.DateTimeFormat(undefined, o).format(d);
    } catch (e) {
      el.textContent = d.toISOString();
    }
  }

  var seen = createSeenSet();

  function run() {
    document.querySelectorAll('time[data-format]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      formatOne(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var mo = new MutationObserver(function () {
    run();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
